<template>
  <inline-svg
    @click="onClickChatbot"
    class="gitple_icon"
    :src="require('@/assets/img/chatbot.svg')"
  />
</template>

<script>
import InlineSvg from "vue-inline-svg";

export default {
  name: "TwcButton",
  components: { InlineSvg },
  setup(_, { emit }) {
    const onClickChatbot = () => {
      emit("onClickChatbot");
    };

    return {
      onClickChatbot,
    };
  },
};
</script>

<style lang="scss" scoped>
.twc-containter {
  width: 100%;
  height: 100%;
  position: absolute;
}
</style>
